import { set } from 'lodash/fp';
import createReducer from '../../../../../helpers/createReducer';
import { createGuest, updateGuest } from '../../../sagas/routines';
import {
  resetGuestForm,
  setIsUploadingFile
} from '../../../actions/components/guest-form';

const initialState = {
  saving: false,
  saved: false,
  isUploadingFile: false,
  savingError: null
};

const createHandler = routine => ({
  [routine.TRIGGER]: state => ({
    ...state,
    saving: true,
    saved: false,
    savingError: null
  }),
  [routine.FAILURE]: (state, { error }) => set('savingError', error, state),
  [routine.FULFILL]: state => ({
    ...state,
    saving: false,
    saved: true,
    savingError: null
  })
});

const updateHandler = routine => ({
  [routine.TRIGGER]: state => ({
    ...state,
    saving: true,
    saved: false,
    savingError: null
  }),
  [routine.FAILURE]: (state, { error }) => set('savingError', error, state),
  [routine.FULFILL]: state => ({
    ...state,
    saving: false,
    saved: true,
    savingError: null
  })
});

const resetHandler = action => ({
  [action.toString()]: () => initialState
});

const setIsUploadingFileHandler = action => ({
  [action.toString()]: (state, { payload: value }) =>
    set('isUploadingFile', value, state)
});

export default createReducer(initialState, {
  ...createHandler(createGuest),
  ...updateHandler(updateGuest),
  ...resetHandler(resetGuestForm),
  ...setIsUploadingFileHandler(setIsUploadingFile)
});
